import React from "react";
import { Link } from "react-router-dom";

import influencer from "../assets/influencer.png";
import user from "../assets/user.png";

function Home() {
  return (
    <div className="bg flex flex-col h-full min-h-screen justify-center items-center">
      <div className="flex flex-col w-4/5 md:w-1/2 lg:w-1/3 justify-center items-center gap-8">
        <Link
          to="/creator/login"
          className="flex py-5 px-4 justify-center items-center w-full rounded-3xl bg-red-400 text-white"
        >
          <div className="flex w-1/2 title uppercase sm:text-2xl lg:text-3xl xl:text-5xl text-center font-bold">
            Login as Creator
          </div>
          <div className="w-1/2">
            <img src={influencer} alt="creator" />
          </div>
        </Link>
        <Link
          to="/user/login"
          className="flex px-4 justify-center w-full bg-cyan-700 text-white py-5 rounded-3xl items-center"
        >
          <div className="flex w-1/2 title uppercase sm:text-2xl lg:text-3xl xl:text-5xl text-center font-bold">
            Login as User
          </div>
          <div className="w-1/2">
            <img src={user} alt="user" />
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Home;
